import { saveUrlSysOptsAction } from './../../actions/system/action';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import apiCommonService from 'bff/services/commonService';
import { FetchUrlSysOptsAction, SYSTEM_FETCH_URL_SYS_OPTS } from 'redux/actions/system/types';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptions } from 'bff/models/info/sysoptions';

/**
 * @description 取得系統參數 Url
 */
function * fetchUrlSysOpts (action: FetchUrlSysOptsAction) {
  const response: SysOptions = yield call(apiCommonService.fetchSysOpts, { PCLASS: [SysOptType.SYSTEM] });
  if (response && response.SYSTEM) {
    yield put(saveUrlSysOptsAction(response.SYSTEM));
  }
  // 查詢完成後回呼，以觸發背景圖更新
  if (action.payload.onComplete) action.payload.onComplete();
}

export function * watchSystemSaga () {
  yield all([
    takeEvery(SYSTEM_FETCH_URL_SYS_OPTS, fetchUrlSysOpts)
  ]);
};
